// extracted by mini-css-extract-plugin
module.exports = {"container":"src-components-ProjectsDetails-ProjectDetails-module__container--5aUCe","logo":"src-components-ProjectsDetails-ProjectDetails-module__logo--3K2HI"};